import React, { useState, useEffect } from 'react';

/**
 * MUI Components
 */
import { Button, TextField, DialogActions, DialogContent, DialogTitle } from '@mui/material';

/**
 * Hooks
 */
import { useTranslation } from 'react-i18next';
import useToken from '../../hooks/useToken';

/**
 * Components
 */
import UserSelector from './userSelector';

/**
 * Utils
 */
import { fetchRecipients } from '../../utils/api';

const SendNotificationForm = ({ onClose, onSubmit }) => {
    const { t } = useTranslation();
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [users, setUsers] = useState([]);
    const [recipient, setRecipient] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const { token } = useToken();

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;

        setLoadingUsers(true);
        try {
            fetchRecipients(token, signal).then(users => {
                setUsers(users);
            });
        } catch (error) {
            console.error('Error fetching users', error);
        } finally {
            setLoadingUsers(false);
        }

        return () => abortController.abort();
    }, [token]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isValid) return;

        onSubmit({
            title,
            message: body,
            type: 'simple',
            uids: recipient.map(r => r.id),
        });
    };

    const isValid = recipient.length > 0 && title.trim() && body.trim();

    return (
        <form onSubmit={handleSubmit}>
            <DialogTitle>{t('Send notification')}</DialogTitle>
            <DialogContent>
                <UserSelector
                    users={users}
                    loading={loadingUsers}
                    value={recipient}
                    onChange={setRecipient}
                />
                <TextField
                    label={t('Subject')}
                    fullWidth
                    margin="normal"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />
                <TextField
                    label={t('Message')}
                    fullWidth
                    margin="normal"
                    multiline
                    rows={4}
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    required
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Cancel')}</Button>
                <Button type="submit" variant="contained" disabled={!isValid}>{t('Send')}</Button>
            </DialogActions>
        </form>
    );
};

export default SendNotificationForm;
